import TagManager, { TagManagerArgs } from "react-gtm-module";

const tagManagerArgs: TagManagerArgs = {
  gtmId: process.env.REACT_APP_GTM_ID || "",
};

export const initializeGTM = () => {
  TagManager.initialize(tagManagerArgs);
};
